import React, { Component, Fragment } from "react";

import NameCard from "../Cards/NameCard";
import PropTypes from "prop-types";
import { Box, Flex } from "rebass";
import InfiniteScroll from "react-infinite-scroller";
import { Circle } from "styled-spinkit";

class UserList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      list: [],
      columnView: false,
      pageStart: 0,
      itemsPerPage: 21,
    };
  }

  // componentDidMount() {
  // 	console.log(this.props.students.length);
  // 	this.setState({list: this.props.students});
  // }

  handleUserClick = (details, e) => {
    const { handleUserClick } = this.props;
    handleUserClick(details, e);
  };

  static getDerivedStateFromProps(props, state) {
    const data = { list: state.list };
    if (props.students.length !== state.list.length) {
      data.list = props.students;
    }
    return data;
  }

  loadMore = (page) => {
    // console.log(page)
    // const {pageStart} = this.state;
    this.setState({ pageStart: page });
  };

  renderStudentList = (students) => {
    const {
      withLocation,
      withHealth,
      selected,
      columnView,
      rosterList,
      current,
      chatPopupWindow,
    } = this.props;

    let listProps = {
      width: [1 / 3, 1 / 4, 1 / 5, 1 / 6],
      p: [0, 1, 1],
    };
    if (columnView) {
      listProps = {
        width: [1 / 3, 1],
        m: 1,
      };
    }

    if (chatPopupWindow) {
      listProps = {
        width: [1 / 3],
        p: [0, 1, 1],
      };
    }
    return (
      <Fragment>
        {students.map((item) => (
          <Box key={item.id} {...listProps}>
            <NameCard
              columnView={columnView}
              current={current}
              details={item}
              withLocation={withLocation}
              withHealth={withHealth}
              handleClick={this.handleUserClick}
              selected={selected.includes(item.id)}
              rosterList={rosterList}
              chatPopupWindow={chatPopupWindow}
            />
          </Box>
        ))}
      </Fragment>
    );
  };

  render() {
    const { pageStart, itemsPerPage, list } = this.state;
    const { infiniteScroll, useWindow } = this.props;

    const items = list.slice(0, itemsPerPage + pageStart * itemsPerPage);

    const hasMore = items.length < list.length;

    return (
      <Fragment>
        {infiniteScroll ? (
          <InfiniteScroll
            pageStart={pageStart}
            loadMore={this.loadMore}
            hasMore={hasMore}
            loader={
              <Flex
                justifyContent={"center"}
                flexWrap={"wrap"}
                width={1}
                key={0}
              >
                <Circle />
              </Flex>
            }
            useWindow={useWindow}
          >
            <Flex width={1} flexWrap={"wrap"}>
              {this.renderStudentList(items)}
            </Flex>
          </InfiniteScroll>
        ) : (
          <Flex width={1} flexWrap={"wrap"}>
            {this.renderStudentList(list)}
          </Flex>
        )}
      </Fragment>
    );
  }
}

UserList.propTypes = {
  withLocation: PropTypes.bool,
  handleUserClick: PropTypes.func,
  students: PropTypes.array,
  selected: PropTypes.array,
  columnView: PropTypes.bool,
  infiniteScroll: PropTypes.bool,
  useWindow: PropTypes.bool,
  rosterList: PropTypes.bool,
  current: PropTypes.string,
};

UserList.defaultProps = {
  withLocation: false,
  columnView: false,
  selected: [],
  handleUserClick: (details) => console.log("Clicked a user", details),
  infiniteScroll: true,
  useWindow: false,
  rosterList: false,
  current: "1",
};
export default UserList;
